import { compose } from "redux";

import DetailedPost from "./Detailed";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import injectLayoutWithQuickLinks from "../InjectLayoutWithQuickLinks";
import extractId from "../ExtractId";

import { getObjectById } from "../../services/MODSService";

const type = "Post";
export default compose(
    extractId(),
    withContainer({
        dataParams: {
            fetchHandler: getObjectById
        },
        defaultLoadingMessage: "Loading Post ",
        Error,
        DefaultComponent: Default
    }),
    injectLayoutWithQuickLinks(type)
)(DetailedPost);
